/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type indexPage_indexQueryVariables = {};
export type indexPage_indexQueryResponse = {
    readonly me: {
        readonly id: string;
        readonly clientID: string;
    } | null;
};
export type indexPage_indexQuery = {
    readonly response: indexPage_indexQueryResponse;
    readonly variables: indexPage_indexQueryVariables;
};



/*
query indexPage_indexQuery {
  me {
    id
    clientID
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserType",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "indexPage_indexQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "indexPage_indexQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "443332a7fb48ba1be372b78fb607adda",
    "id": null,
    "metadata": {},
    "name": "indexPage_indexQuery",
    "operationKind": "query",
    "text": "query indexPage_indexQuery {\n  me {\n    id\n    clientID\n  }\n}\n"
  }
};
})();
(node as any).hash = '239a2f981d53dfeb5c1f0c41b3709938';
export default node;
